import * as React from 'react';
import consultants from '../img/panel/consultants.png';
import clients from '../img/panel/clients.png';
import proposals from '../img/panel/proposals.png';
import adminLogo from '../img/panel/admin.png';
import contract from '../img/panel/contract.png';
import { Saveable, SaveableState1 } from './Saveable';
import * as ClientHome from '../client/Home';
import { CustomerProposals } from './CustomerProposals';
import { checkCurrentUrl } from '../util';
import * as ClientAccount from '../client/Account';
// import { override } from '../LoginUpdate';
// import { BarLoader } from 'react-spinners';
import { Modal2 } from './modal/modal2/Modal2';

export const logout = async (e: any ) => {
  if (e) {
      e.preventDefault();
  }
  await ClientHome.logout();
  // await ClientHome.sessionStatus();
  setTimeout(
      () => {
          window.location.reload();
          location.href = '/#/login';
      },
      1000);
};

window['logout'] = logout;
export interface Props {
  superAdmin: boolean;
  accountType: string;
}
export class SideBar extends Saveable<Props, SaveableState1> {
  menuOptions = {
    admin:[
    {id: '0', icon: consultants, text: 'Recent', href: '/#/recent', isSelected: false},
    {id: '1', icon: consultants, text: 'Manage Consultants', href: '/#/consultants', isSelected: false},
    {id: '2', icon: clients, text: 'Manage Customers', href: '/#/clients', isSelected: false},
    {id: '3', icon: proposals, text: 'Manage Proposals', href: '/#/proposals', isSelected: false},
  ],
  superAdmin: [
    {id: '6', icon: adminLogo, text: 'Manage Admins', href: '/#/admins', isSelected: false},
    {id: '7', icon: contract, text: 'Manage Contracts', href: '/#/contracts', isSelected: false},
  ],
  consultant: [
    {id: '8', icon: adminLogo, text: 'My Availability', href: '/#/availabilityCalendar', isSelected: false},
    {id: '9', icon: contract, text: 'My Profiles', href: '/#/profileVersions', isSelected: false},
    {id: '10', icon: contract, text: 'My Account', href: '/#/selfProfile', isSelected: false},
  ],
  // client: {test: <CustomerProposals />}
};
  constructor(props: Props) {
    super(props);
    this.state = {saved: true, currentUrl: '', name: '', accountType: '', superAdmin: false, loading: false};
}

logout11 = async (e: any ) => {
  this.setState({...this.state, loading: true});
  document.body.style.overflow = 'hidden';
  console.log('121212121');
  if (e) {
      e.preventDefault();
  }
  await ClientHome.logout();
  // await ClientHome.sessionStatus();
  setTimeout(
      () => {
          location.href = '/#/login';
          window.location.reload();
          this.setState({...this.state, loading: false});
          document.body.style.overflow = 'unset';
      },
      1000);
}

async componentDidMount() {
  console.log('hhhhh');
  this.state.loading ? document.body.style.overflow = 'hidden' : document.body.style.overflow = 'unset';
  // document.body.style.overflow = 'hidden';
  // console.log(checkCurrentUrl('ok'));
  const result = await ClientAccount.getAccountSelf();
  if (result.status !== 403) {
      const state = await result.json();
      this.setState({name: state.firstName, accountType: state.accountType, superAdmin: state.superAdmin});
  }
}

componentWillMount() {
  console.log('kkkkkk');
  console.log(checkCurrentUrl('ok'));
  this.setState({...this.state, currentUrl: checkCurrentUrl('ok')});
  this.testForFun('/#/' + checkCurrentUrl('ok'), 'admin');
}

initialSetting () {
  Object.keys(this.menuOptions).forEach( (key) => {
    this.menuOptions[key].map((el: { href: string; isSelected: boolean; }) => el.isSelected = false);
});
  // Object.entries(this.menuOptions).forEach(([key, value]) => console.log(`${key}: ${value}`));
  // this.menuOptions['admin'].map((el: { href: string; isSelected: boolean; }) => el.isSelected = false);
  // this.menuOptions['superAdmin'].map((el: { href: string; isSelected: boolean; }) => el.isSelected = false);
  // this.menuOptions['consultant'].map((el: { href: string; isSelected: boolean; }) => el.isSelected = false);
}
     
// testForFun3(href: string, categoryType: string) {
//   window.location.href = href;
//   this.initialSetting();
//   this.menuOptions[categoryType].map((el: { href: string; isSelected: boolean; }) => el.href === href ? el.isSelected = true : el.isSelected = false);
//  }
    testForFun(href: string, categoryType: string) {
      window.location.href = href;
      this.initialSetting();
      this.menuOptions[categoryType].map((el: { href: string; isSelected: boolean; }) => el.href === href ? el.isSelected = true : el.isSelected = false);
     }

     testForFun2(loggedIn: string) {
      window.location.href = loggedIn ? '#/recent' : 'undefined';
      window.location.reload();
     }
    render() {
      const {accountType, superAdmin} = this.props;
      const admin = accountType === 'admin';
      const consultant = accountType === 'consultant';
      const client = accountType === 'client';
      const loggedIn = accountType;
      // console.log('superAdmin:   ' + superAdmin);
      // console.log('admin:   ' + admin);
      // console.log('consultant:   ' + consultant);
      // console.log('client:   ' + client);
      return (
        <div className={'side-bar-main-container ' + (this.state.loading ? '' : 'hidden')}>
          <div className="sidebar-header-custom" onClick={() => this.testForFun2(loggedIn)}>
                  <span className="logo-text">Axceller</span>
                  <img className="logo-icon" src="favicon.ico" style={{width: '34px', height: '34px', marginLeft: '0.25em', marginRight: '0.25em'}}/>
            </div>
            <hr className="separator"/>
            <div className="sidebar-content-custom">
              <div className="sidebar-content-greeting">
              <span>Good Morning,</span>
              <p>{this.state.name}</p>
              </div>
              <div className="sidebar-body-custom">
               {admin ? 
                  this.menuOptions['admin'].map( item => 
                    <span className="item-wrapper" key={item.id} onClick={() => this.testForFun(item.href, 'admin')}>
                      <img className="menu-item-icon" src={item.icon} style={{width: '1em', marginLeft: '0.25em', marginRight: '0.25em'}}/>
                      <span className={'menu-item-text ' + (item.isSelected ? 'active' : '')}>{item.text}</span>
                    </span>
                  )
                 : null }
                 {superAdmin ? 
                  this.menuOptions['superAdmin'].map( item => 
                    <span className="item-wrapper" key={item.id} onClick={() => this.testForFun(item.href, 'superAdmin')}>
                      <img className="menu-item-icon" src={item.icon} style={{width: '1em', marginLeft: '0.25em', marginRight: '0.25em'}}/>
                      <span className={'menu-item-text ' + (item.isSelected ? 'active' : '')}>{item.text}</span>
                    </span>
                  )
                 : null }
                 {consultant ? 
                  this.menuOptions['consultant'].map( item => 
                    <span className="item-wrapper" key={item.id} onClick={() => this.testForFun(item.href, 'consultant')}>
                      <img className="menu-item-icon" src={item.icon} style={{width: '1em', marginLeft: '0.25em', marginRight: '0.25em'}}/>
                      <span className={'menu-item-text ' + (item.isSelected ? 'active' : '')}>{item.text}</span>
                    </span>
                  )
                 : null }
                 {client ? <CustomerProposals /> : null}
              </div>

            </div>
            <div className="sidebar-footer-custom">
                <span className="footer-text" onClick={() => this.logout11(event)}>Logout</span>
            </div>
            <Modal2  show={this.state.loading}/>
            {/* <div className="loading-wrapper" style={{ position: 'fixed', top: '50%', bottom: '50%'}}>
                    <BarLoader color={'red'} loading={this.state.loading} cssOverride={override} height={4} width={1500} speedMultiplier={0.5} />
                </div> */}
          </div>
        );
      }
}



// WEBPACK FOOTER //
// ./src/widgets/SideBar.tsx